import { render, staticRenderFns } from "./fournisseur_list.vue?vue&type=template&id=453ace95&"
import script from "./fournisseur_list.vue?vue&type=script&lang=js&"
export * from "./fournisseur_list.vue?vue&type=script&lang=js&"
import style0 from "./fournisseur_list.vue?vue&type=style&index=0&id=453ace95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports